module.exports = __webpack_public_path__ + "img/swiper-17.1189d4bf.png";